import { motion } from "motion/react";
import { useGetImages, useSetNextImage } from "../api";
import { useEffect, useState } from "react";
import { GalleryCard } from "./GalleryCard";
import { useInView } from "react-intersection-observer";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const Gallery = () => {

  const [currImages, setCurrImages] = useState<{ images: string[], next: string | null } | undefined>(undefined)

  const setNewImagesHandler = (data: { images: string[], next: string | null }) => {
    setCurrImages(prev => {
      if(prev){
        const newImages = [...prev.images, ...data.images]
        return { images: newImages, next: data.next }
      }
    })
  }

  const { setNewImages } = useSetNextImage(setNewImagesHandler)

  const { ref } = useInView({
    threshold: 0,  // trigger as soon as it comes into view
    onChange: (inView) => {
      if (inView) {
        // call post api here
        if (currImages && currImages.next !== null) {
          setNewImages(currImages.next)
        }
      }
    },
  });

  const { landingGallery } = useGetImages()

  useEffect(() => {
    if (landingGallery) {
      setCurrImages({
        images: landingGallery.images,
        next: landingGallery.next_start_after
      })
    }
  }, [landingGallery])

  return (
    <div className="relative min-h-screen">
      {/* Header */}
      <motion.div
        className=" pb-12 px-6 text-center"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }}
      >
        <motion.p
          className="text-xl text-muted-foreground max-w-2xl mx-auto font-poppins tracking-wide"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }}
        >
          Discover a curated collection of stunning visual experiences created autonomously by siAi
        </motion.p>
      </motion.div>

      {/* Gallery Grid */}
      <div className="px-6 pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {currImages && currImages.images.map((image, index) => (
              <GalleryCard
                alt=""
                key={index}
                src={image}
                index={index}
              />
            ))}
          </div>
          <div className={cn("w-full py-4 flex justify-center",
          ( currImages && currImages.next !== null ) ? "flex" : "hidden")} ref={ref}><Loader2 className="animate-spin" /></div>
        </div>
      </div>

    </div>
  );
};
